var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2315 6.41859C26.3243 6.32581 26.3979 6.21566 26.4481 6.09444C26.4983 5.97321 26.5241 5.84328 26.5241 5.71207C26.5241 5.58085 26.4983 5.45093 26.4481 5.3297C26.3979 5.20847 26.3243 5.09833 26.2315 5.00554C26.1387 4.91276 26.0286 4.83916 25.9073 4.78895C25.7861 4.73874 25.6562 4.71289 25.525 4.71289C25.3938 4.71289 25.2638 4.73874 25.1426 4.78895C25.0214 4.83916 24.9112 4.91276 24.8184 5.00554L15.5458 14.2802L6.27315 5.00554C6.18037 4.91276 6.07022 4.83916 5.94899 4.78895C5.82776 4.73874 5.69784 4.71289 5.56662 4.71289C5.43541 4.71289 5.30548 4.73874 5.18425 4.78895C5.06303 4.83916 4.95288 4.91276 4.8601 5.00554C4.76731 5.09833 4.69372 5.20847 4.6435 5.3297C4.59329 5.45093 4.56744 5.58085 4.56744 5.71207C4.56744 5.84328 4.59329 5.97321 4.6435 6.09444C4.69372 6.21566 4.76731 6.32581 4.8601 6.41859L14.1347 15.6912L4.8601 24.9639C4.67271 25.1513 4.56744 25.4054 4.56744 25.6704C4.56744 25.9354 4.67271 26.1896 4.8601 26.3769C5.04748 26.5643 5.30162 26.6696 5.56662 26.6696C5.83162 26.6696 6.08577 26.5643 6.27315 26.3769L15.5458 17.1023L24.8184 26.3769C25.0058 26.5643 25.26 26.6696 25.525 26.6696C25.79 26.6696 26.0441 26.5643 26.2315 26.3769C26.4189 26.1896 26.5241 25.9354 26.5241 25.6704C26.5241 25.4054 26.4189 25.1513 26.2315 24.9639L16.9568 15.6912L26.2315 6.41859Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.92bfe9760a50673a57e6ce30fe7bc1b5.svg";
export { ForwardRef as ReactComponent };